import React from 'react';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Label } from '../Label/Label';

interface Props {
  id: string;
  label: string;
}

export const Setting: React.FC<Props> = ({ id, label, children }) => {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" my="16">
      <Label htmlFor={id}>{label}</Label>

      <Box width={240}>{children}</Box>
    </Box>
  );
};
